import styles from "./EmptyCell.module.css";

/**
 * Em dash rendered in place of an absent cell value.
 */
const EMPTY_DASH = "—";

/**
 * Renders the shared em dash for an absent cell value, muted so it reads as
 * intentionally-empty rather than broken. Reuse anywhere a cell needs the
 * empty state (e.g. a custom cell renderer's empty branch).
 */
export function EmptyCell() {
  return <span className={styles.dash}>{EMPTY_DASH}</span>;
}
